import React, {Component, Fragment} from "react";
import PropTypes from 'prop-types';
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {FichaTecnicaService} from "../../../../services/FichaTecnicaService/FichaTecnicaService";
import {FieldsJs, hideSpinner, showSpinner} from "../../../../settings/General/General";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import BoxSelectFile from "../../../Include/MiniComponents/BoxSelectFile";
import TextField from "@material-ui/core/TextField";
import {DateFormat} from "../../../../settings/DateFormat/DateFormat";
import {Icono} from "../../../Include/Icono/Icono";
import ModalImage from "../../../Include/ModalImage/ModalImage";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {ClientePotencialService} from "../../../../services/ClientePotencialService/ClientePotencialService";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";
import Fab from "@material-ui/core/Fab";
import {CloudUploadOutlined, SyncOutlined} from "@material-ui/icons";
import ArchivosExpedientes from "../../FichaTecnica/Includes/ArchivosExpedientes";
import {CONFIG} from "../../../../settings/Config/Config";
import {DropboxApi} from "../../../../settings/Dropbox/DropboxApi";
import ChatFichaTecnica from "./ChatFichaTecnica";

class SubirContratoPrestacionServicio extends Component {
	
	state = {};
	
	Usr = {};
	showSnackBars = this.props.showSnackBars;
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			modal: {
				open: false
			},
			id_cliente: props.id_cliente,
			
			cliente: {},
			
			id_cat_ficha_tecnica_status: '',
			fecha_firma_contrato: '',
			ficha_tecnica_archivo_integracion_expediente: [],
			
			contrato_prestacion_servicio_base64: '',
			contrato_prestacion_servicio_base64Tipo: '',
			contrato_prestacion_servicio_archivo: '',
			contrato_prestacion_servicio_formato: '',
			
			observaciones: '',
			
			cliente_contrato_prestacion_servicio: [],
			
			file:[],
			archivo: '',
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		FieldsJs.HandleChange(e, variable, campo, date, input, (r) => this.setState({
			[r.name]: r.value
		}));
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
		console.log(this.state, props);
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	BOTON_ACCION_IMAGEN = (item) => {
		let BTNS = '';
		let tipo = item.id_ficha_tecnica_archivo_propuesta_fiscal > 0 ? 'view' : 'add';
		switch (tipo) {
			case 'add':
				BTNS = (<Fragment>
					<ModalImage tipo={tipo} desing={1} item={item}/>
				</Fragment>);
				break;
			case 'view':
				BTNS = (<Fragment>
					{/*<ModalImage tipo={tipo} desing={1} item={item}/>*/}
					<Button size="small" color="primary" onClick={() => this.viewDbx(item)} className={'cursor-pointer'}>
						Ver
					</Button>
				</Fragment>);
				break;
			default:
		}
		return BTNS;
	};
	
	init = () => {
		return new Promise((resolve, reject) => {
			FichaTecnicaService.InitDato(this.state.id_cliente).then((response) => {
				
				let dato = FieldsJs.Copy(response.data);
				
				if (response.visible === 0) {
					
					this.setState({
						visible: 0,
						mensaje: response.message
					});
					
				} else {
					
					let cliente_contrato_prestacion_servicio = dato.cliente_contrato_prestacion_servicio || [];
					let ficha_tecnica_archivo_integracion_expediente = dato.ficha_tecnica_archivo_integracion_expediente || [];
					
					this.setState({
						
						visible: 1,
						
						cliente: dato.cliente,
						
						id_cat_ficha_tecnica_status: (dato.ficha_tecnica || {}).id_cat_ficha_tecnica_status || '',
						fecha_firma_contrato: (dato.ficha_tecnica || {}).fecha_firma_contrato || '',
						ficha_tecnica_archivo_integracion_expediente: ficha_tecnica_archivo_integracion_expediente,
						
						cliente_contrato_prestacion_servicio: cliente_contrato_prestacion_servicio,
						
					});
					
				}
				resolve(true);
			}).catch((error) => {
				this.props.showSnackBars('error', error.mensaje);
				reject(false)
			});
		});
	};
	
	RefreshInit = () => {
		this.init();
	};
	
	getBase64 = (e, dropzone) => {
		return new Promise((resolve, reject) => {
			let files;
			if (dropzone) {
				files = e;
			} else {
				console.log(e.target);
				files = e.target.files;
			}
			
			//let namearchivo = (this.state.contrato_prestacion_servicio.length === 0 ? "Contrato_Prestacion_Servicio":"Contrato_Prestacion_Servicio"+(Number(this.state.contrato_prestacion_servicio.length)+1))+'.'+this.state.contrato_prestacion_servicio_formato;
			let namearchivo = "Contrato_Prestacion_Servicio"+'.'+this.state.contrato_prestacion_servicio_formato;
			
			let ruta = '/' + this.state.cliente.rfc + '-' + FieldsJs.getClienteTipoPersona(this.state.cliente) + '/contrato/' + namearchivo;
			
			console.log(ruta, files);
			
			DropboxApi.Upload(ruta, files).then(function (response) {
				
				resolve(response.path_display);
				
			}).catch(function (error) {
				reject(error);
			});
		});
	};
	
	save = () => {
		try {
			
			console.log("SAVE FORMATO ALTA ::: ", this.state);
			
			if (this.state.file.length === 0) {
				throw Object({
					status: 400,
					mensaje: "El archivo de contrato de prestacion de servicio es requerido."
				});
			}
			
			showSpinner('spinner');
			
			this.getBase64(this.state.file[0], true).then(response => {
				let archivos = FieldsJs.Copy(this.state.archivo);
				
				this.setState({
					archivo: response
				});
				
				console.log("SAVE 222 FORMATO ALTA ::: ", this.state);
				
				hideSpinner('spinner', 600);
				
				ClientePotencialService.SubirContratoPrestacionServicio(this.state).then((response) => {
					
					this.props.RefreshList();
					
					this.close();
					
					this.showSnackBars('success', response.mensaje);
					
				}).catch((error) => {
					this.props.showSnackBars('error', error.mensaje);
				});
				
			});
			
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	desactivar_nomina_empleados = (item, key) => {
		try {
			PopupService.Confirm(['Cancelar', 'Aceptar'], 'warning', CONFIG.titulo_alert_confirm, '¿Estas seguro de desactivar el contrato de prestacion deservicios?').then((r) => {
				if (r.button === 'Aceptar') {
					ClientePotencialService.DesactivarContratoPrestacionServicio(item, key).then((response) => {
						
						this.RefreshInit();
						
						this.showSnackBars('success', response.mensaje);
						
					}).catch((error) => {
						this.props.showSnackBars('error', error.mensaje);
					});
				}
			});
			
		} catch (e) {
			this.props.showSnackBars('error', e.mensaje);
		}
	};
	
	disabledFieldPromotorSubirFormatoAltaBajaEmpleadoBolean = () => {
		
		let disabledFieldPromotorSubirFormatoAltaBajaEmpleado = true;
		
		if (FieldsJs.inArray([1, 2, 5], this.Usr.id_cat_tipo_usuario) && FieldsJs.inArray([7, 8, 9, 10, 11, 12], this.state.id_cat_ficha_tecnica_status)) {
			disabledFieldPromotorSubirFormatoAltaBajaEmpleado = false;
		}
		
		return disabledFieldPromotorSubirFormatoAltaBajaEmpleado;
	};
	
	exportar = (path) => {
		//path = CONFIG.src + path;
		DropboxApi.Download(path).then(function (data) {
			console.log('Descarga con éxito!');
		}).catch(function (error) {
			console.error(error);
		});
		//window.open(path, '', 'width=900, height=600');
	};
	
	render() {
		
		const disabledFieldPromotorSubirFormatoAltaBajaEmpleado = this.disabledFieldPromotorSubirFormatoAltaBajaEmpleadoBolean();
		
		return (
			<div>
				
				<span onClick={() => this.open()} style={{cursor: "pointer"}}>
					{this.props.icono}
				</span>
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'md'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogTitle>
						<Grid container spacing={0}>
							<Grid item xs={12}>
								<Typography className={'px-20'}>
									<Fab size="small" color="secondary" aria-label="Actualizar"
									     onClick={() => this.RefreshInit()} style={{marginRight: '15px'}}>
										<SyncOutlined/>
									</Fab>
									{this.props.titulo}
								</Typography>
							</Grid>
						</Grid>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2} alignContent={"flex-start"} alignItems={"flex-start"}>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6} align={'left'}>
								
								<Typography className={'margin-0 padding-0 px-14'}>
									Fecha programada para firma de contratos:<br/>
									{DateFormat.FechaFormatString(this.state.fecha_firma_contrato)}
								</Typography>
								
								<div style={{width: '100%', padding: '10px'}} align={'center'}>
									<div style={{
										backgroundColor: "black",
										color: "white",
										borderRadius: '5px',
										padding: '2px 10px 2px 10px',
										width: '100px'
									}} align={'center'}>
										<Typography className={'margin-0 padding-0 px-14'}>
											Expedientes
										</Typography>
									</div>
								</div>
								
								<Grid container spacing={2}>
									
									{this.state.ficha_tecnica_archivo_integracion_expediente.map((item, key) => (
										<Grid key={key} item className={'text-left'} xs={6} sm={6} md={4} lg={4} xl={4}>
											<ArchivosExpedientes
												index={key}
												variable={'archivo_integracion_expediente'}
												texto={item.archivo_integracion_expediente}
												id_ficha_tecnica_archivo_integracion_expediente={item.id_ficha_tecnica_archivo_integracion_expediente || ""}
												id_cat_archivo_integracion_expediente={item.id_cat_archivo_integracion_expediente || ""}
												item={{
													loading: !!item.loading,
													base64: item.base64,
													formato: item.formato,
													archivo: item.archivo,
													is_required: item.is_required,
												}}
												fileSelect={() => {
												}}
												getBase64={() => {
												}}
												disabledSeleccionarCambiarArchivo={true}
												width={40}
												height={40}
												desing={3}
												padding={10}
											/>
										</Grid>
									))}
								
								</Grid>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={6} lg={6} xl={6} align={'left'}>
								
								<Grid container spacing={2} alignContent={"flex-end"} alignItems={"flex-end"}>
									
									{!disabledFieldPromotorSubirFormatoAltaBajaEmpleado ? (
										<Fragment>
											
											<Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
												
												<BoxSelectFile
													style={{height: '130px'}}
													label={(
														<div>
															Contrato <b className={'vertical-inline v-center text-blue'}>(Requerido)</b>
														</div>
													)}
													item={{
														base64: this.state.contrato_prestacion_servicio_base64,
														base64Tipo: this.state.contrato_prestacion_servicio_base64Tipo,
														archivo: this.state.contrato_prestacion_servicio_archivo,
														formato: this.state.contrato_prestacion_servicio_formato,
													}}
													onChange={(r) => {
														this.handleChange({
															target: {
																name: 'contrato_prestacion_servicio_base64',
																value: r.base64
															}
														});
														this.handleChange({
															target: {
																name: 'contrato_prestacion_servicio_base64Tipo',
																value: r.base64Tipo
															}
														});
														this.handleChange({
															target: {
																name: 'contrato_prestacion_servicio_archivo',
																value: r.archivo
															}
														});
														this.handleChange({
															target: {
																name: 'file',
																value: r.file
															}
														});
														this.handleChange({
															target: {
																name: 'contrato_prestacion_servicio_formato',
																value: r.formato
															}
														});
													}}
													showSnackBars={this.showSnackBars}
													disabled={disabledFieldPromotorSubirFormatoAltaBajaEmpleado}
												/>
											
											</Grid>
											
											<Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
												
												<Grid container spacing={1}>
													
													<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
														
														<TextField
															multiline
															fullWidth
															onChange={this.handleChange}
															type="text"
															margin="normal"
															rows={3}
															variant={"filled"}
															//required
															name="observaciones"
															label="Observaciones"
															placeholder="Escribe aquí algún dato adicional"
															value={this.state.observaciones}
															disabled={disabledFieldPromotorSubirFormatoAltaBajaEmpleado}
														/>
													
													</Grid>
													
													<Grid item xs={12} sm={12} md={12} lg={12} xl={12} align={'right'}>
														
														{!disabledFieldPromotorSubirFormatoAltaBajaEmpleado ? (
															<Fab style={{fontSize: '12px', width: '100px', height: '30px'}}
															     variant="extended"
															     size="small"
															     color="primary"
															     aria-label="Subir contrato"
															     onClick={() => this.save()}
															
															     disabled={disabledFieldPromotorSubirFormatoAltaBajaEmpleado}
															>
																<CloudUploadOutlined style={{fontSize: '14px', marginRight: '10px'}}/> Subir
															</Fab>
														) : ''}
													
													</Grid>
												
												</Grid>
											
											</Grid>
										
										</Fragment>
									) : null}
									
									<Grid item xs={12} sm={12} md={12} lg={12} xl={12} align={'left'}>
										
										<Card>
											<CardContent style={{background: 'lightgray', padding: '15px'}}>
												
												<Grid container spacing={2} alignContent={"center"} alignItems={"center"}>
													
													{this.state.cliente_contrato_prestacion_servicio.map((item, key) => (
														<Fragment key={key}>
															<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
																
																<Card style={{height: '100%'}}>
																	<CardContent style={{padding: '10px'}}>
																		
																		<div align={'right'}
																		     style={{
																			     width: '100%',
																			     height: 0
																		     }}
																		>
																			{!disabledFieldPromotorSubirFormatoAltaBajaEmpleado ? (
																				<Fragment>
																					<div
																						className={'cursor-pointer'}
																						style={{
																							textAlign: 'center',
																							marginLeft: 5,
																							float: 'right',
																							padding: '6px',
																							background: 'red',
																							height: '6px',
																							width: '6px',
																							lineHeight: '6px',
																							color: 'white',
																							borderRadius: '100%',
																							fontSize: '12px',
																						}}
																						onClick={() => this.desactivar_nomina_empleados(item, key)}
																						children={'x'}
																					/>
																				</Fragment>
																			) : null}
																		</div>
																		
																		<Typography
																			className={'text-right text-black margin-0 padding-0 px-14 h-0-px'}>
																			{item.created_at ? DateFormat.FechaHoraFormatText(item.created_at) : ''}
																		</Typography>
																		
																		{item.contrato_prestacion_servicio_archivo ? (
																			<div className="vertical-inline">
																				<div className={'v-center'}>
																					<Typography
																						className={'text-left text-black margin-0 padding-0 px-14'}>
																						Contrato:
																					</Typography>
																				</div>
																				<div
																					className={'padding-5-L padding-5-R v-center'}>
																					{Icono.get(item.contrato_prestacion_servicio_formato, '20px', '20px')}
																				</div>
																				<div className={'v-center padding-10-R'}>
																					<Typography className={'px-13 margin-0 cursor-pointer'} style={{color: "blue"}} onClick={() => this.exportar(item.contrato_prestacion_servicio)}>
																						Descargar
																					</Typography>
																					{/*<Fragment>
																						<ModalImage tipo={'view'} desing={3} item={{
																							base64: item.contrato_prestacion_servicio_base64 || '',
																							base64Tipo: item.contrato_prestacion_servicio_base64Tipo || '',
																							archivo: item.contrato_prestacion_servicio_archivo || '',
																							formato: item.contrato_prestacion_servicio_formato || '',
																						}}/>
																					</Fragment>*/}
																				</div>
																			</div>
																		) : ''}
																		
																		<Typography className={'text-left text-black margin-0 padding-0'}>
																			Observaciones: {item.observaciones || 'Sin observaciones'}
																		</Typography>
																	
																	</CardContent>
																</Card>
															
															</Grid>
														</Fragment>
													))}
													
													{this.state.cliente_contrato_prestacion_servicio.length <= 0 ? (
														<Fragment>
															<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
																<VistaVacia
																	paddingText={'10px'}
																	padding={'10px'}
																	numero={0}
																	mensaje={'No se ha registrado el contrato de prestación de servicio.'}
																	height={'70px'}
																	width={'70px'}
																/>
															</Grid>
														</Fragment>
													) : ''}
												
												</Grid>
											
											</CardContent>
										</Card>
									
									</Grid>
									
								</Grid>
								
								<ChatFichaTecnica
									modulo={6}
									state={this.state}
									BOTON_ACCION_IMAGEN={this.BOTON_ACCION_IMAGEN}
									showSnackBars={this.props.showSnackBars}
									handleChange={this.handleChange}
								/>
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<DialogActions>
						<Grid container spacing={1}>
							<Grid item xs={6} align={'left'}>
								<Button onClick={() => this.close()} color="primary">
									Cerrar
								</Button>
							</Grid>
							<Grid item xs={6} align={'right'}>
							
							</Grid>
						</Grid>
					</DialogActions>
				
				</Dialog>
			
			
			</div>
		);
	}
}

SubirContratoPrestacionServicio.propTypes = {
	titulo: PropTypes.string.isRequired,
	id_cliente: PropTypes.number.isRequired,
	icono: PropTypes.element.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default SubirContratoPrestacionServicio;
